import { render, staticRenderFns } from "./PartyDetailsGuestsTab.vue?vue&type=template&id=c0c63a94"
import script from "./PartyDetailsGuestsTab.vue?vue&type=script&lang=js"
export * from "./PartyDetailsGuestsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports